//
// 下拉菜单
// ============================================================
import DropdownPublic from "./dropdown-public";

const Dropdown = options => DropdownPublic(options);

module.exports = Dropdown;


// WEBPACK FOOTER //
// src/js/dropdown.js